

<template >
    <div >
        <vue-editor 
        style="min-height: 300px;" 
         v-model="model"   :config="config" 
           useCustomImageHandler
          @image-added="handleImageAdded"
        />
    </div>
	<!-- <div class="btnBox textRight">
		<button class="mr10" @click="openPreview('preview')">PC 미리보기</button>
		<button @click="openPreview('previewMob')">Mobile 미리보기</button>
	</div> -->
	<!-- <Modal name="preview"  width="1200px" :button="true" title="미리보기"> 
		<div class="ck-content htmlBox" v-html="modelValue">
		</div>
		<template v-slot:footer>
			<div class="btnBox">
				<button  @click="closeModal('preview')">닫기</button>
			</div>
		</template>
	</Modal>
	<Modal name="previewMob"  width="500px" :button="true" title="미리보기"> 
		<div class="ck-content htmlBox mobile">
			<div v-html="modelValue" ></div>
		</div>
		<template v-slot:footer>
			<div class="btnBox">
				<button  @click="closeModal('previewMob')">닫기</button>
			</div>
		</template>
	</Modal> -->
</template>

<script lang="ts">
import { ref, watch,reactive  } from 'vue';

import { VueEditor, Quill } from "vue2-editor";

import axios from 'axios' 
const baseUrl = process.env.VUE_APP_API_URL
 

export default {
  components: {
    VueEditor
  },
  props: {
      modelValue: {
          type: String,
          default: ''
      },
      
  },
  emits: ['update:modelValue'],
  data() {
    return {
      


      isLayoutReady: false,
      config: {

        toolbar: [ 'heading', '|', 'bold', 'italic' ] 
      }, // CKEditor needs the DOM tree before calculating the configuration.
      previewData : null,
    }
  },
  created() {
    ClassicEditor
      .create( document.querySelector( '#editor' ) )
      .then( editor => {
        window.editor = editor;
      } )
      .catch( error => {
        console.error( 'There was a problem initializing the editor.', error );
      } );

  },
	watch: {
		 
	},
    computed:{
        model:{
			get() {
				return this.modelValue;
			},
			set(value) {
				this.$emit("update:modelValue", value);
			}
        }
    },
    mounted(){
        this.config = {
			    tabIndex:3,
            extraPlugins: [],
			toolbar: {
				items: [
                    'undo',
					'redo',
					'|',
					'sourceEditing',
					'showBlocks',
					'|',
					'heading',
					'|',
					'alignment',
					'fontSize',
					'fontFamily',
					'fontColor',
					'fontBackgroundColor',
					"underline",
					'|',
					'bold',
					'italic',
					'code',
					'|',
					'link',
					'insertImage',
					'ckbox',
					'insertTable',
					//'codeBlock',
					'|',
					'bulletedList',
					'numberedList',
					//'|',
					//'accessibilityHelp'
				],
				shouldNotGroupWhenFull: false
			},
			plugins: [
				// AccessibilityHelp,
				// Alignment,
				// Autoformat,
				// AutoImage,
				// AutoLink,
				// Autosave,
				// Bold,
				// CloudServices,
				// Code,
				// CodeBlock,
				// Essentials,
				// FontBackgroundColor,
				// FontColor,
				// FontFamily,
				// FontSize,
				// GeneralHtmlSupport,
				// Heading,
        // ImageUpload,
				// ImageBlock,
				// ImageCaption,
				// ImageInline,
				// ImageInsertViaUrl,
				// ImageResize,
				// ImageStyle,
				// ImageTextAlternative,
				// ImageToolbar,
				// Italic,
				// Link,
				// LinkImage,
				// List,
				// ListProperties,
				// Paragraph,
				// ShowBlocks,
				// SourceEditing,
				// Table,
				// TableCaption,
				// TableCellProperties,
				// TableColumnResize,
				// TableProperties,
				// TableToolbar,
				// TextTransformation,
				// Undo,
				// Underline
			],
			fontFamily: {
				supportAllValues: true
			},
			fontSize: {
				options: [10, 12, 14, 16, 'default',20, 22,24, 26, 28, 30,32],
				supportAllValues: true
			},
			heading: {
				options: [
					{
						model: 'paragraph',
						title: 'Paragraph',
						class: 'ck-heading_paragraph'
					},
					{
						model: 'heading1',
						view: 'h1',
						title: 'H1 (30,26)',
						class: 'ck-heading_heading1'
					},
					{
						model: 'heading2',
						view: 'h2',
						title: 'H2 (26,22)',
						class: 'ck-heading_heading2'
					},
					{
						model: 'heading3',
						view: 'h3',
						title: 'H3 (22,20)',
						class: 'ck-heading_heading3'
					},
					 
				]
			},
			htmlSupport: {
				allow: [
					{
						name: /^.*$/,
						styles: true,
						attributes: true,
						classes: true
					}
				]
			},
			image: {
				toolbar: [
					'toggleImageCaption',
					'imageTextAlternative',
					'|',
					'imageStyle:inline',
					'imageStyle:wrapText',
					'imageStyle:breakText',
					'|',
					'resizeImage'
				]
			},
			initialData:this.model,
				
			link: {
				addTargetToExternalLinks: true,
				defaultProtocol: 'https://',
				decorators: {
					toggleDownloadable: {
						mode: 'manual',
						label: 'Downloadable',
						attributes: {
							download: 'file'
						}
					}
				}
			},
			list: {
				properties: {
					styles: true,
					startIndex: true,
					reversed: true
				}
			},
			placeholder: 'Type or paste your content here!',
			table: {
				contentToolbar: ['tableColumn', 'tableRow', 'mergeTableCells', 'tableProperties', 'tableCellProperties']
			},
			 
		};

		this.isLayoutReady = true;
		 
    },
	methods:{
		openPreview(type){
            this.previewData = this.modelValue
            this.openModal(type)
        }
    }
  }
  </script>
<style lang="scss">
  

</style>